/**
 * Cookie Settings Button Component
 *
 * A button component to reopen cookie consent settings.
 * Typically placed in the footer to allow users to change their preferences.
 *
 * @module components/Organisms/CookieConsent/CookieSettingsButton
 */

import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Button } from '../../Atoms/ESSButton/Button';
import { useCookieConsent } from './useCookieConsent';
import './CookieSettingsButton.scss';

const messages = defineMessages({
  cookieSettings: {
    id: 'Cookie Settings',
    defaultMessage: 'Cookie Settings',
  },
  manageCookies: {
    id: 'Manage Cookies',
    defaultMessage: 'Manage Cookies',
  },
});

/**
 * CookieSettingsButton Component
 *
 * @param {Object} props
 * @param {string} props.variant - Button variant (default: 'text')
 * @param {string} props.label - Custom label (optional)
 * @param {string} props.className - Additional CSS classes
 */
const CookieSettingsButton = ({
  variant = 'text',
  label,
  className = '',
  ...props
}) => {
  const intl = useIntl();
  const { resetConsent } = useCookieConsent();

  const buttonLabel = label || intl.formatMessage(messages.cookieSettings);

  return (
    <Button
      variant={variant}
      onClick={resetConsent}
      className={`ess-cookie-settings-button ${className}`}
      {...props}
    >
      {buttonLabel}
    </Button>
  );
};

export default CookieSettingsButton;
